export const INPUT_PATTERNS_CONSTANT = {
  NUMBER: /^\d+$/,
  NUMBER_RANGE: /^3\d{9}$/,
};
